module.exports = __webpack_public_path__ + "media/images/iphone-12-metrics-486ce9ac.png";